import { ITHSRStore } from './interfaces';
import * as actionTypes from './actionTypes';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(isSameOrAfter);

const initialState = {
    THSROptsMOpen: null,
    THSRInitData: null,
    THSRIsInitFail: false,
    THSRDetailData: null,
    TCurrentStep: null,
    THSRStations: null,
    THSRDetailLoading: false,
    THSROtherTimeLoading: null,
    THSRSearchOption: null,
    THSROpenedPanel: null,
    THSRInfo: null,
    THSRDepartTrain: null,
    THSRReturnTrain: null,
    THSRHighestDiscounts: null,
    THSRTempTrainItems: null,
};

const reducer = (state: ITHSRStore = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_THSROPTSMOPEN:
            return { ...state, THSROptsMOpen: action.payload };
        case actionTypes.SET_THSRINITDATA:
            return { ...state, THSRInitData: action.payload };
        case actionTypes.SET_THSRISINITFAIL:
            return { ...state, THSRIsInitFail: action.payload };
        case actionTypes.SET_THSRDETAILDATA:
            return { ...state, THSRDetailData: action.payload };
        case actionTypes.SET_TCURRENTSTEP:
            return { ...state, TCurrentStep: action.payload };
        case actionTypes.SET_THSRSTATIONS:
            return { ...state, THSRStations: action.payload };
        case actionTypes.SET_THSRDETAILLOADING:
            return { ...state, THSRDetailLoading: action.payload };
        case actionTypes.SET_THSRSEARCHOPTION:
            return { ...state, THSRSearchOption: action.payload };
        case actionTypes.SET_THSROPENEDPANEL:
            return { ...state, THSROpenedPanel: action.payload };
        case actionTypes.SET_THSRInfo:
            if (action.payload?.ProductUseDate) {
                // 篩掉昨天以前的日期，避免最後票券使用日有可能可以選到已經過去的日期
                const dates = action.payload?.ProductUseDate?.filter((item: string) =>
                    dayjs(item).isSameOrAfter(dayjs(), 'dates')
                );
                return {
                    ...state,
                    THSRInfo: { ...action.payload, ProductUseDate: dates },
                };
            }
            return { ...state, THSRInfo: action.payload };

        case actionTypes.SET_THSRDEPARTTRAIN:
            return { ...state, THSRDepartTrain: action.payload };
        case actionTypes.SET_THSRRETURNTRAIN:
            return { ...state, THSRReturnTrain: action.payload };

        case actionTypes.SER_THSROTHERTIMELOADING:
            return { ...state, THSROtherTimeLoading: action.payload };
        case actionTypes.SET_THSRHIGHESTDISCOUNTS:
            return { ...state, THSRHighestDiscounts: action.payload };
        case actionTypes.SET_THSRTEMPTRAINITEMS:
            return { ...state, THSRTempTrainItems: action.payload };
        default:
            return state;
    }
};

export default reducer;
